<template lang="pug" src="./home.pug"></template>

<script>
import HeroHome from 'components/hero/hero-home/hero-home'
import BannerCtaForm from 'components/banner/banner-cta-form/banner-cta-form'
import CustomHomeDoctor from 'components/custom/custom-home-doctor/custom-home-doctor'
import TabHomeAbout from 'components/tab/tab-home-about/tab-home-about'
import CustomHomeSmile from 'components/custom/custom-home-smile/custom-home-smile'
import CustomHomeFollow from 'components/custom/custom-home-follow/custom-home-follow'
import SliderHomeTestimonials from 'components/slider/slider-home-testimonials/slider-home-testimonials'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages['home']
    }
  },
  components: {
    HeroHome,
    BannerCtaForm,
    CustomHomeDoctor,
    TabHomeAbout,
    CustomHomeSmile,
    CustomHomeFollow,
    SliderHomeTestimonials
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/home.vue